import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import moment from "moment";
import { renderRedirect } from "../util";
import {fetchSignApplication, updateSignApplication} from "./BasicProfile/api"
import { mutation } from "../api";
import Footer from "../Components/footer";
import './AddNominee/SwitchStyles.css'

const countriesList = [
  "India",
  "United States",
  "United Kingdom",
  "Canada",
  "Australia",
  "Germany",
  "Singapore",
  "United Arab Emirates",
  "Others"
];

class AdditionalDetails extends Component {
  renderRedirect = () => {
    if(this.state.isAddNominee){
      renderRedirect(this.props, "/add-nominee");
    }else{
      renderRedirect(this.props, "/bank-cheque");
    }
  };

  constructor(props) {
    super(props);
    this.state = {
      fathersName: "",
      mothersName: "",
      occupationType: "",
      otherOccupation: "",
      annualIncome: "",
      isValidated: false,
      politicallyExposed: null,
      isAddNominee:false,
      netWorthDate:null,
      netWorth:null,
      trust_sms: "yes",
      annual_report_despatch_mode: "electronic",
      rta_email_share: "yes",
      transaction_alerts_preference: "",
      is_joint_account: false,
      joint_holder_second_fullname: "",
      joint_holder_second_mobile: "",
      joint_holder_second_sign: "",
      joint_holder_third_fullname: "",
      joint_holder_third_mobile: "",
      joint_holder_third_sign: "",
      fatcaTaxResident: "No",
      fatcaCountryBirth: "",
      fatcaCountryTaxResidency: "",
      fatcaTin: "",
      fatcaDeclared: false,
      option_form_issue_dis_booklet_option2: "yes",
      errors: {
        fathersName: "",
        mothersName: "",
        occupationType: "",
        otherOccupation: "",
        annualIncome: "",
        politicallyExposed: "",
        netWorth: "",
        netWorthDate: "",
        fatcaCountryBirth: "",
        fatcaCountryTaxResidency: "",
        fatcaTin: "",
        fatcaDeclared: "",
        transaction_alerts_preference: "",
      },
    };
  }

  validateForm = () => {
    const isOtherOccupationValid = this.state.occupationType !== "others" || (
      this.state.otherOccupation && this.state.otherOccupation.trim() !== ""
    );
    const isFatcaValid = this.state.fatcaTaxResident === "No" || (
      this.state.fatcaCountryBirth && this.state.fatcaCountryBirth.trim() !== "" &&
      this.state.fatcaCountryTaxResidency && this.state.fatcaCountryTaxResidency.trim() !== "" &&
      this.state.fatcaTin && this.state.fatcaTin.trim() !== ""
    );

    let isJointValid = true;
    if (this.state.is_joint_account) {
      const isSecondValid = 
        this.state.joint_holder_second_fullname && this.state.joint_holder_second_fullname.trim() !== "" &&
        this.state.joint_holder_second_mobile && this.state.joint_holder_second_mobile.trim() !== "" &&
        this.state.joint_holder_second_sign && this.state.joint_holder_second_sign.trim() !== "";
      
      const hasThirdData = 
        (this.state.joint_holder_third_fullname && this.state.joint_holder_third_fullname.trim() !== "") ||
        (this.state.joint_holder_third_mobile && this.state.joint_holder_third_mobile.trim() !== "") ||
        (this.state.joint_holder_third_sign && this.state.joint_holder_third_sign.trim() !== "");
        
      const isThirdValid = !hasThirdData || (
        this.state.joint_holder_third_fullname && this.state.joint_holder_third_fullname.trim() !== "" &&
        this.state.joint_holder_third_mobile && this.state.joint_holder_third_mobile.trim() !== "" &&
        this.state.joint_holder_third_sign && this.state.joint_holder_third_sign.trim() !== ""
      );
      
      isJointValid = isSecondValid && isThirdValid;
    }

    if (
      this.state.fathersName && this.state.fathersName !== "" &&
      this.state.mothersName && this.state.mothersName !== "" &&
      this.state.occupationType && this.state.occupationType !== "" &&
      isOtherOccupationValid &&
      this.state.annualIncome && this.state.annualIncome !== "" &&
      this.state.transaction_alerts_preference && this.state.transaction_alerts_preference !== "" &&
      this.state.politicallyExposed && this.state.politicallyExposed !== "" &&
      this.state.netWorthDate && this.state.netWorthDate !== "" &&
      this.state.netWorth && this.state.netWorth !== "" &&
      isFatcaValid &&
      isJointValid &&
      this.state.fatcaDeclared
    ) {
      this.setState({["isValidated"]: true});
      return true;
    } else {
      this.setState({["isValidated"]: false});
      return false;
    }
  };
  async componentDidMount() {
    let profileData = await fetchSignApplication();
    if(profileData && profileData.data && profileData.data.fetch_signup_application){
      let data = profileData.data.fetch_signup_application;
      const hasNominees = data.nominee_consent ?? (data.nominees && data.nominees.length > 0);
      this.setState({["fathersName"]: data.fathersName || ""});
      this.setState({["mothersName"]: data.mothersName || ""});
      this.setState({["occupationType"]: data.occupationType || ""});
      this.setState({["otherOccupation"]: data.otherOccupation || ""});
      this.setState({["annualIncome"]: data.annualIncome ? decodeURIComponent(data.annualIncome) : ""});
      this.setState({["politicallyExposed"]: data.isPoliticalyExposed || ""});
      this.setState({ ["netWorthDate"]: data.net_worth_date ? moment(data.net_worth_date).format("YYYY-MM-DD"): "" });
      this.setState({['netWorth']:data.net_worth || ""});
      this.setState({["trust_sms"]: data.trust_sms || "yes"});
      this.setState({["annual_report_despatch_mode"]: data.annual_report_despatch_mode || "electronic"});
      this.setState({["rta_email_share"]: data.rta_email_share || "yes"});
      this.setState({["transaction_alerts_preference"]: data.transaction_alerts_preference || ""});
      this.setState({["is_joint_account"]: data.is_joint_account || false});
      this.setState({["joint_holder_second_fullname"]: data.joint_holder_second_fullname || ""});
      this.setState({["joint_holder_second_mobile"]: data.joint_holder_second_mobile || ""});
      this.setState({["joint_holder_second_sign"]: data.joint_holder_second_sign || ""});
      this.setState({["joint_holder_third_fullname"]: data.joint_holder_third_fullname || ""});
      this.setState({["joint_holder_third_mobile"]: data.joint_holder_third_mobile || ""});
      this.setState({["joint_holder_third_sign"]: data.joint_holder_third_sign || ""});
      this.setState({["fatcaTaxResident"]: data.fatcaTaxResident || "No"});
      this.setState({["fatcaCountryBirth"]: data.fatcaCountryBirth || ""});
      this.setState({["fatcaCountryTaxResidency"]: data.fatcaCountryTaxResidency || ""});
      this.setState({["fatcaTin"]: data.fatcaTin || ""});
      this.setState({["fatcaDeclared"]: data.fatcaDeclared || false});
      this.setState({["kraIsVerified"]: data.kra_is_verified || false});
      this.setState({["option_form_issue_dis_booklet_option2"]: data.option_form_issue_dis_booklet_option2 || "yes"});
      this.setState({ isAddNominee: hasNominees });
    }
    this.validateForm();
  }


  handleChange = (event) => {
    const { id, value, type, checked } = event.target;
    let errors = this.state.errors;
    const val = type === "checkbox" ? checked : value;

    switch (id) {
      case "fathersName":
        if (value.length < 1) {
          //  errors.fathersName = "Father's name cannot be empty";
        } else {
          errors.fathersName = "";
          this.setState({["fathersName"]: value});
        }
        break;
      case "mothersName":
        if (value.length < 1) {
         // errors.mothersName = "Mother's name cannot be empty";
        } else {
          errors.mothersName = "";
          this.setState({["mothersName"]: value});
        }
        break;
      case "occupationType":
        if (value.length < 1) {
          //errors.occupationType = "Occupation Type cannot be empty";
        } else {
          errors.occupationType = "";
          this.setState({["occupationType"]: value});
        }
        break;
      case "otherOccupation":
        errors.otherOccupation = "";
        this.setState({["otherOccupation"]: value});
        break;
      case "annualIncome":
        if (value.length < 1) {
         // errors.annualIncome = "Annual Income  cannot be empty";
        } else {
          errors.annualIncome = "";
          this.setState({["annualIncome"]: value});
        }
        break;
      case "politicallyExposed":
        errors.politicallyExposed = "";
        this.setState({["politicallyExposed"]: value});
        break;
      case "netWorth":
        errors.netWorth = "";
        this.setState({["netWorth"]: value});
        break;
      case "netWorthDate":
        errors.netWorthDate = "";
        this.setState({["netWorthDate"]: value});
        break;
      case "fatcaCountryBirth":
        errors.fatcaCountryBirth = "";
        break;
      case "fatcaCountryTaxResidency":
        errors.fatcaCountryTaxResidency = "";
        break;
      case "fatcaTin":
        errors.fatcaTin = "";
        break;
      case "fatcaDeclared":
        errors.fatcaDeclared = "";
        break;
      default:
        break;
    }
    this.setState({ errors, [id]: val });
    window.setTimeout(function () {
      this.validateForm();
    }.bind(this), 600);
  };

  handleSubmit = async(event) => {
    event.preventDefault();

    // Validate and show errors on empty required fields
    if (!this.validateForm()) {
      const errors = { ...this.state.errors };
      if (!this.state.fathersName) errors.fathersName = "Father's Name is required";
      if (!this.state.mothersName) errors.mothersName = "Mother's Name is required";
      if (!this.state.occupationType) errors.occupationType = "Occupation Type is required";
      if (this.state.occupationType === "others" && !this.state.otherOccupation) errors.otherOccupation = "Specify Occupation is required";
      if (!this.state.annualIncome) errors.annualIncome = "Annual Income is required";
      if (!this.state.politicallyExposed) errors.politicallyExposed = "PEP status is required";
      if (!this.state.netWorthDate) errors.netWorthDate = "Net Worth Date is required";
      if (!this.state.netWorth) errors.netWorth = "Net Worth is required";
      if (this.state.fatcaTaxResident === "Yes") {
        if (!this.state.fatcaCountryBirth) errors.fatcaCountryBirth = "Country of Birth is required";
        if (!this.state.fatcaCountryTaxResidency) errors.fatcaCountryTaxResidency = "Country of Tax Residency is required";
        if (!this.state.fatcaTin) errors.fatcaTin = "TIN is required";
      }
      if (!this.state.fatcaDeclared) errors.fatcaDeclared = "You must accept the declaration to proceed";
      if (!this.state.transaction_alerts_preference) errors.transaction_alerts_preference = "Transaction Alerts Preference is required";
      
      this.setState({ errors }, () => {
        const firstError = document.querySelector('.error');
        if (firstError) firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
      return;
    }

    let reqParam = {
      fathersName: this.state.fathersName,
      mothersName: this.state.mothersName,
      occupationType: this.state.occupationType,
      otherOccupation: this.state.occupationType === "others" ? this.state.otherOccupation : "",
      annualIncome: this.state.annualIncome,
      isPoliticalyExposed: this.state.politicallyExposed,
      net_worth_date: this.state.netWorthDate
            ? moment(this.state.netWorthDate).format("DD-MM-YYYY")
            : this.state.netWorthDate,
      net_worth:this.state.netWorth,
      trust_sms: this.state.trust_sms || "yes",
      annual_report_despatch_mode: this.state.annual_report_despatch_mode || "electronic",
      rta_email_share: this.state.rta_email_share || "yes",
      transaction_alerts_preference: this.state.transaction_alerts_preference || "sms_and_email",
      is_joint_account: this.state.is_joint_account,
      joint_holder_second_fullname: this.state.is_joint_account ? this.state.joint_holder_second_fullname : "",
      joint_holder_second_mobile: this.state.is_joint_account ? this.state.joint_holder_second_mobile : "",
      joint_holder_second_sign: this.state.is_joint_account ? this.state.joint_holder_second_sign : "",
      joint_holder_third_fullname: this.state.is_joint_account ? this.state.joint_holder_third_fullname : "",
      joint_holder_third_mobile: this.state.is_joint_account ? this.state.joint_holder_third_mobile : "",
      joint_holder_third_sign: this.state.is_joint_account ? this.state.joint_holder_third_sign : "",
      nominee_consent: this.state.isAddNominee,
      fatcaTaxResident: this.state.fatcaTaxResident,
      fatcaCountryBirth: this.state.fatcaCountryBirth,
      fatcaCountryTaxResidency: this.state.fatcaCountryTaxResidency,
      fatcaTin: this.state.fatcaTin,
      fatcaDeclared: this.state.fatcaDeclared,
      option_form_issue_dis_booklet_option2: this.state.option_form_issue_dis_booklet_option2 || "yes"
    };
    let updateProfile = await updateSignApplication(reqParam);
    if (updateProfile && updateProfile.data && updateProfile.data.update_signup_application && updateProfile.data.update_signup_application.status) {
      this.renderRedirect();
    } else {
      alert(updateProfile?.data?.update_signup_application?.message || "Failed to update profile details.");
    }
  };

  handleNomineeSwitch=(e)=>{
    this.setState({isAddNominee:e.target.checked})
  }

  handleEcnChange = (e) => {
    this.setState({ annual_report_despatch_mode: e.target.value });
  }

  handleTrustChange = (e) => {
    this.setState({ trust_sms: e.target.value });
  }

  handleRtaChange = (e) => {
    this.setState({ rta_email_share: e.target.value });
  }

  handleAlertsPreferenceChange = (e) => {
    let errors = this.state.errors;
    errors.transaction_alerts_preference = "";
    this.setState({ transaction_alerts_preference: e.target.value, errors }, this.validateForm);
  }

  handleJointSwitch = (e) => {
    const checked = e.target.checked;
    if (checked) {
      const confirmProceed = window.confirm("Please note: This option is only if you are opening a joint DP account with us. Are you sure you want to proceed?");
      if (!confirmProceed) {
        return;
      }
    }
    this.setState({ is_joint_account: checked }, this.validateForm);
  }

  toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  handleFileUpload = async (event, fieldName) => {
    try {
      const file = event.target.files[0];
      if (!file) return;
      this.setState({ [`${fieldName}_uploading`]: true });
      const base64 = await this.toBase64(file);
      const response = await mutation(
        "upload_file",
        { image_data: base64, file_name: file.name },
        `image_url status message`,
        "file"
      );
      if (response && response.data && response.data.upload_file && response.data.upload_file.status) {
        this.setState({
          [fieldName]: response.data.upload_file.image_url,
          [`${fieldName}_uploading`]: false
        }, this.validateForm);
      } else {
        this.setState({ [`${fieldName}_uploading`]: false });
        alert(response?.data?.upload_file?.message || "File upload failed");
      }
    } catch (e) {
      this.setState({ [`${fieldName}_uploading`]: false });
      alert("Error: " + e.message);
    }
  }

  render() {
    const { errors } = this.state;
    return (      <div className="col-md-6 col-lg-5 col-xl-4">

      <div className="container my-auto py-4 bg-white shadow-lg rounded">
        <div className="row mt-2">
          <div className="col-11 col-lg-11 mx-auto">
            <h1>Additional Details</h1>
            <form id="registerForm" className="form-border">
              <div className="form-group icon-group">
                <input
                  type="text"
                  className="form-control floating-label-field floating-label-field--s1"
                  id="fathersName"
                  required
                  placeholder="Father's Name"
                  onChange={this.handleChange}
                  onBlur={this.handleChange}
                  value={this.state.fathersName}
                /> <label className="floating-label">Father's Name</label>
                <span className="icon-inside text-primary">
                  <i className="fas fa-user"></i>
                </span>
                {errors.fathersName.length > 0 && (
                  <span className="error">{errors.fathersName}</span>
                )}
              </div>
              <div className="form-group icon-group">
                <input
                  type="text"
                  className="form-control floating-label-field floating-label-field--s1"
                  id="mothersName"
                  required
                  placeholder="Mother's Name"
                  onChange={this.handleChange}
                  onBlur={this.handleChange}
                  value={this.state.mothersName}
                /> <label className="floating-label">Mother's Name</label>
                <span className="icon-inside text-primary">
                  <i className="fas fa-user"></i>
                </span>
                {errors.mothersName.length > 0 && (
                  <span className="error">{errors.mothersName}</span>
                )}
              </div>
              <div className="form-group icon-group"><select
                  id="occupationType"
                  className="form-control floating-label-field floating-label-field--s1"
                  onChange={this.handleChange}
                  onBlur={this.handleChange}
                  noValidate
                  value={this.state.occupationType}
                >
                  <option value="">Select an option</option>

                  <option value="pvt_sector">Private Sector</option>
                  <option value="gov_service">Government Service</option>
                  <option value="pub_sector">Public Sector</option>
                  <option value="agriculturist">Agriculturalist</option>
                  <option value="professional">Professional</option>
                  <option value="business">Business</option>
                  <option value="housewife">Housewife</option>
                  <option value="retired">Retired</option>
                  <option value="student">Student</option>
                  <option value="others">Others</option>
                </select> <label className="floating-label">Occuption Type</label>
                <span className="icon-inside text-primary">
                  <i className="fas fa-user-md"></i>
                </span>
                {errors.occupationType.length > 0 && (
                  <span className="error">{errors.occupationType}</span>
                )}
              </div>
              {this.state.occupationType === "others" && (
                <div className="form-group icon-group floating-label-wrap">
                  <input
                    type="text"
                    className="form-control floating-label-field floating-label-field--s1"
                    id="otherOccupation"
                    required
                    placeholder="Specify Occupation"
                    onChange={this.handleChange}
                    onBlur={this.handleChange}
                    value={this.state.otherOccupation || ""}
                  />
                  <label className="floating-label">Specify Occupation</label>
                  <span className="icon-inside text-primary">
                    <i className="fas fa-briefcase"></i>
                  </span>
                  {errors.otherOccupation && errors.otherOccupation.length > 0 && (
                    <span className="error">{errors.otherOccupation}</span>
                  )}
                </div>
              )}
              <div className="form-group icon-group">
                <select
                  id="annualIncome"
                  className="form-control floating-label-field floating-label-field--s1"
                  onChange={this.handleChange}
                  onBlur={this.handleChange}
                  noValidate
                  value={this.state.annualIncome}
                > 
                  <option value="">Select an option</option>
                  <option value="less_than_1_lakh">Below 1 Lakh</option>
                  <option value="one_to_5_lakh">1 Lakh - 5 Lakh</option>
                  <option value="five_to_10_lakh">5 Lakh to 10 Lakh</option>
                  <option value="ten_to_25_lakh">10 Lakh to 25 Lakh</option>
                  <option value="greater_than_25_lakh">Above 25 Lakh</option>
                </select><label className="floating-label">Annual Income</label>
                <span className="icon-inside text-primary">
                  <i className="fa fa-rupee-sign"></i>
                </span> 
                {errors.annualIncome.length > 0 && (
                  <span className="error">{errors.annualIncome}</span>
                )}
              </div>
              <div className="form-group icon-group">
                
                  <select
                    id="politicallyExposed"
                    className="form-control floating-label-field floating-label-field--s1"
                    noValidate
                    value={this.state.politicallyExposed}
                    onChange={this.handleChange}
                    onBlur={this.handleChange}
                  >
                    <option value="">Select an option</option>
                    <option value="No">No / Not Applicable</option>
                    <option value="Yes">Politically Exposed Person (PEP)</option>
                    <option value="RPEP">Related to Politically Exposed Person (RPEP)</option>
                  </select>
                  <label className="floating-label">Politically Exposed</label>
                <span className="icon-inside text-primary">
                  <i className="fas fa-user-shield"></i>
                </span>
                {errors.politicallyExposed.length > 0 && (
                  <span className="error">{errors.politicallyExposed}</span>
                )}
              </div>

              <div className="form-group icon-group">
                <input
                  type="date"
                  className="form-control floating-label-field floating-label-field--s1"
                  id="netWorthDate"
                  required
                  placeholder="Net Worth Date"
                  onChange={this.handleChange}
                  onBlur={this.handleChange}
                  value={this.state.netWorthDate}
                  max={moment().format("YYYY-MM-DD")}
                  onKeyDown={(e) => e.preventDefault()}
                /> <label className="floating-label">Net Worth Date</label>
                <span className="icon-inside text-primary">
                  <i className="fas fa-calendar"></i>
                </span>
                {errors.netWorthDate.length > 0 && (
                  <span className="error">{errors.netWorthDate}</span>
                )}
              </div>
 
              <div className="form-group icon-group">
                <input
                  type="number"
                  className="form-control floating-label-field floating-label-field--s1"
                  id="netWorth"
                  required
                  placeholder="Net Worth"
                  onChange={this.handleChange}
                  onBlur={this.handleChange}
                  value={this.state.netWorth}
                  min={0}
                /> <label className="floating-label">Net Worth</label>
                <span className="icon-inside text-primary">
                  <i className="fas fa-briefcase"></i>
                </span>
                {errors.netWorth.length > 0 && (
                  <span className="error">{errors.netWorth}</span>
                )}
              </div>


              <div className="form-group" style={{ marginBottom: '1.5rem' }}>
                <label style={{ fontSize: '14px', fontWeight: 'bold', display: 'block', marginBottom: '5px', color: '#555' }}>
                  Contract Note Delivery Preference
                </label>
                <div style={{ display: 'flex', gap: '20px' }}>
                  <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', fontSize: '14px', color: '#555' }}>
                    <input
                      type="radio"
                      name="annual_report_despatch_mode"
                      value="electronic"
                      checked={this.state.annual_report_despatch_mode === "electronic"}
                      onChange={this.handleEcnChange}
                      style={{ marginRight: '5px' }}
                    />
                    Electronic (Email)
                  </label>
                  <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', fontSize: '14px', color: '#555' }}>
                    <input
                      type="radio"
                      name="annual_report_despatch_mode"
                      value="physical"
                      checked={this.state.annual_report_despatch_mode === "physical"}
                      onChange={this.handleEcnChange}
                      style={{ marginRight: '5px' }}
                    />
                    Physical
                  </label>
                </div>
              </div>

              <div className="form-group" style={{ marginBottom: '1.5rem' }}>
                <label style={{ fontSize: '14px', fontWeight: 'bold', display: 'block', marginBottom: '5px', color: '#555' }}>
                  Opt for SMS Alerts facility (TRUST)?
                </label>
                <div style={{ display: 'flex', gap: '20px' }}>
                  <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', fontSize: '14px', color: '#555' }}>
                    <input
                      type="radio"
                      name="trust_sms"
                      value="yes"
                      checked={this.state.trust_sms === "yes"}
                      onChange={this.handleTrustChange}
                      style={{ marginRight: '5px' }}
                    />
                    Yes
                  </label>
                  <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', fontSize: '14px', color: '#555' }}>
                    <input
                      type="radio"
                      name="trust_sms"
                      value="no"
                      checked={this.state.trust_sms === "no"}
                      onChange={this.handleTrustChange}
                      style={{ marginRight: '5px' }}
                    />
                    No
                  </label>
                </div>
                <div style={{ fontSize: '12px', color: '#666', marginTop: '10px' }}>
                  <i className="fas fa-info-circle" style={{ marginRight: '5px' }}></i>
                  By opting for SMS alerts, you agree to the{' '}
                  <a
                    href="https://www.cdslindia.com/downloads/Investors/FAQs/RIGHTS-AND-OBLIGATIONS.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ textDecoration: 'underline', color: '#007bff' }}
                  >
                    Terms and Conditions prescribed by CDSL
                  </a>
                </div>
              </div>

              <div className="form-group" style={{ marginBottom: '1.5rem' }}>
                <label style={{ fontSize: '14px', fontWeight: 'bold', display: 'block', marginBottom: '5px', color: '#555' }}>
                  Share email with RTA for electronic statements?
                </label>
                <div style={{ display: 'flex', gap: '20px' }}>
                  <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', fontSize: '14px', color: '#555' }}>
                    <input
                      type="radio"
                      name="rta_email_share"
                      value="yes"
                      checked={this.state.rta_email_share === "yes"}
                      onChange={this.handleRtaChange}
                      style={{ marginRight: '5px' }}
                    />
                    Yes
                  </label>
                  <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', fontSize: '14px', color: '#555' }}>
                    <input
                      type="radio"
                      name="rta_email_share"
                      value="no"
                      checked={this.state.rta_email_share === "no"}
                      onChange={this.handleRtaChange}
                      style={{ marginRight: '5px' }}
                    />
                    No
                  </label>
                </div>
              </div>

              <div className="form-group" style={{ marginBottom: '1.5rem' }}>
                <label style={{ fontSize: '14px', fontWeight: 'bold', display: 'block', marginBottom: '5px', color: '#555' }}>
                  Transaction Alerts Preference <span className="text-danger">*</span>
                </label>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                  <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', fontSize: '14px', color: '#555' }}>
                    <input
                      type="radio"
                      name="transaction_alerts_preference"
                      value="sms_and_email"
                      checked={this.state.transaction_alerts_preference === "sms_and_email"}
                      onChange={this.handleAlertsPreferenceChange}
                      style={{ marginRight: '8px' }}
                    />
                    I/We want to receive transaction alerts in SMS as well as Email
                  </label>
                  <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', fontSize: '14px', color: '#555' }}>
                    <input
                      type="radio"
                      name="transaction_alerts_preference"
                      value="sms_only"
                      checked={this.state.transaction_alerts_preference === "sms_only"}
                      onChange={this.handleAlertsPreferenceChange}
                      style={{ marginRight: '8px' }}
                    />
                    I/We want to receive transaction alerts only in SMS
                  </label>
                  <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', fontSize: '14px', color: '#555' }}>
                    <input
                      type="radio"
                      name="transaction_alerts_preference"
                      value="email_only"
                      checked={this.state.transaction_alerts_preference === "email_only"}
                      onChange={this.handleAlertsPreferenceChange}
                      style={{ marginRight: '8px' }}
                    />
                    I/We want to receive transaction alerts only in Email
                  </label>
                </div>
                {errors.transaction_alerts_preference && errors.transaction_alerts_preference.length > 0 && (
                  <span className="error" style={{ display: 'block', marginTop: '5px' }}>{errors.transaction_alerts_preference}</span>
                )}
              </div>

              {/* FATCA Tax Residency section */}
              <div className="form-group" style={{ marginBottom: '1.5rem' }}>
                <label style={{ fontSize: '14px', fontWeight: 'bold', display: 'block', marginBottom: '5px', color: '#555' }}>
                  Are you a tax resident of any country other than India?
                </label>
                <div style={{ display: 'flex', gap: '20px' }}>
                  <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', fontSize: '14px', color: '#555' }}>
                    <input
                      type="radio"
                      id="fatcaTaxResidentNo"
                      name="fatcaTaxResident"
                      value="No"
                      checked={this.state.fatcaTaxResident === "No"}
                      onChange={() => this.setState({ fatcaTaxResident: "No", fatcaCountryBirth: "", fatcaCountryTaxResidency: "", fatcaTin: "" }, this.validateForm)}
                      style={{ marginRight: '5px' }}
                    />
                    No
                  </label>
                  <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', fontSize: '14px', color: '#555' }}>
                    <input
                      type="radio"
                      id="fatcaTaxResidentYes"
                      name="fatcaTaxResident"
                      value="Yes"
                      checked={this.state.fatcaTaxResident === "Yes"}
                      onChange={() => this.setState({ fatcaTaxResident: "Yes" }, this.validateForm)}
                      style={{ marginRight: '5px' }}
                    />
                    Yes
                  </label>
                </div>
              </div>

              {this.state.fatcaTaxResident === "Yes" && (
                <div style={{ paddingLeft: '15px', borderLeft: '3px solid #007bff', marginBottom: '1.5rem' }}>
                  <div className="form-group icon-group">
                    <select
                      id="fatcaCountryBirth"
                      className="form-control floating-label-field floating-label-field--s1"
                      onChange={this.handleChange}
                      onBlur={this.handleChange}
                      value={this.state.fatcaCountryBirth}
                    >
                      <option value="">Select Country of Birth</option>
                      {countriesList.map((c) => (
                        <option key={c} value={c}>{c}</option>
                      ))}
                    </select>
                    <label className="floating-label">Country of Birth</label>
                    <span className="icon-inside text-primary">
                      <i className="fas fa-globe"></i>
                    </span>
                    {errors.fatcaCountryBirth && errors.fatcaCountryBirth.length > 0 && (
                      <span className="error">{errors.fatcaCountryBirth}</span>
                    )}
                  </div>

                  <div className="form-group icon-group">
                    <select
                      id="fatcaCountryTaxResidency"
                      className="form-control floating-label-field floating-label-field--s1"
                      onChange={this.handleChange}
                      onBlur={this.handleChange}
                      value={this.state.fatcaCountryTaxResidency}
                    >
                      <option value="">Select Country of Tax Residency</option>
                      {countriesList.map((c) => (
                        <option key={c} value={c}>{c}</option>
                      ))}
                    </select>
                    <label className="floating-label">Country of Tax Residency</label>
                    <span className="icon-inside text-primary">
                      <i className="fas fa-passport"></i>
                    </span>
                    {errors.fatcaCountryTaxResidency && errors.fatcaCountryTaxResidency.length > 0 && (
                      <span className="error">{errors.fatcaCountryTaxResidency}</span>
                    )}
                  </div>

                  <div className="form-group icon-group">
                    <input
                      type="text"
                      className="form-control floating-label-field floating-label-field--s1"
                      id="fatcaTin"
                      required
                      placeholder="Tax Identification Number (TIN)"
                      onChange={this.handleChange}
                      onBlur={this.handleChange}
                      value={this.state.fatcaTin}
                    />
                    <label className="floating-label">Tax Identification Number (TIN)</label>
                    <span className="icon-inside text-primary">
                      <i className="fas fa-id-card"></i>
                    </span>
                    {errors.fatcaTin && errors.fatcaTin.length > 0 && (
                      <span className="error">{errors.fatcaTin}</span>
                    )}
                  </div>
                </div>
              )}

              {/* FATCA Consent Checkbox */}
              <div className="form-group form-check text-left pl-0 my-3" style={{ display: "flex", alignItems: "flex-start" }}>
                <input
                  type="checkbox"
                  id="fatcaDeclared"
                  style={{ width: "20px", height: "20px", marginRight: "10px", marginTop: "3px", cursor: "pointer" }}
                  checked={this.state.fatcaDeclared}
                  onChange={this.handleChange}
                />
                <label className="form-check-label text-2 text-muted mb-0" htmlFor="fatcaDeclared" style={{ cursor: "pointer", userSelect: "none", fontSize: "12px", lineHeight: "1.4" }}>
                  {this.state.fatcaTaxResident === "Yes" 
                    ? "I declare that the information provided is true and correct. I am an Indian citizen, a tax resident of the countries specified above, and my political exposure status is as declared."
                    : "I declare that the information provided is true and correct. I am an Indian citizen, a tax resident of India only, and I am not a Politically Exposed Person (PEP)."}
                </label>
              </div>
              {errors.fatcaDeclared && errors.fatcaDeclared.length > 0 && (
                <div className="error text-left mb-3" style={{ fontSize: "12px", color: "red" }}>{errors.fatcaDeclared}</div>
              )}

              <div className="form-group" style={{ marginBottom: '1.5rem', marginTop: '1rem' }}>
                <label style={{ fontSize: '14px', fontWeight: 'bold', display: 'block', marginBottom: '5px', color: '#555' }}>
                  Do you require a physical DIS (Delivery Instruction Slip) booklet?
                </label>
                <span style={{ display: 'block', fontSize: '12px', color: '#666', marginBottom: '8px' }}>
                  If you choose "No", you confirm Option 2: you do not require a physical DIS booklet for the time being since you use eDIS/DDPI.
                </span>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                  <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', fontSize: '14px', color: '#555' }}>
                    <input
                      type="radio"
                      name="option_form_issue_dis_booklet_option2"
                      value="no"
                      checked={this.state.option_form_issue_dis_booklet_option2 === "no"}
                      onChange={(e) => this.setState({ option_form_issue_dis_booklet_option2: e.target.value })}
                      style={{ marginRight: '8px' }}
                    />
                    Yes (I want a physical DIS booklet)
                  </label>
                  <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', fontSize: '14px', color: '#555' }}>
                    <input
                      type="radio"
                      name="option_form_issue_dis_booklet_option2"
                      value="yes"
                      checked={this.state.option_form_issue_dis_booklet_option2 === "yes"}
                      onChange={(e) => this.setState({ option_form_issue_dis_booklet_option2: e.target.value })}
                      style={{ marginRight: '8px' }}
                    />
                    No (Option 2: Not required for now)
                  </label>
                </div>
              </div>

              <div>
                <span className="icon-inside text-primary">
                  <label>Do you wish to add nominee?</label>
                </span>
              </div>
                           
              <div className="form-group icon-group">
                   <label className="switch">
                        <input className="switch-input" type="checkbox" checked={this.state.isAddNominee} onChange={this.handleNomineeSwitch} />
                        <span className="switch-label" data-on="Yes" data-off="No"></span>
                        <span className="switch-handle"></span>
                   </label>
              </div>

              <div>
                <span className="icon-inside text-primary">
                  <label>Joint DP account?</label>
                </span>
                <span style={{ display: 'block', fontSize: '12px', color: '#666', marginBottom: '8px' }}>
                  Is this going to be a joint account? You can add up to 2 extra joint holders.
                </span>
              </div>

              <div className="form-group icon-group">
                   <label className="switch">
                        <input className="switch-input" type="checkbox" checked={this.state.is_joint_account} onChange={this.handleJointSwitch} />
                        <span className="switch-label" data-on="Yes" data-off="No"></span>
                        <span className="switch-handle"></span>
                   </label>
              </div>

              {this.state.is_joint_account && (
                <div style={{ padding: '15px', border: '1px solid #ddd', borderRadius: '4px', background: '#f9f9f9', marginBottom: '1.5rem' }}>
                  <h4 style={{ fontSize: '15px', marginBottom: '15px', fontWeight: 'bold' }}>Second Joint Holder Details</h4>
                  
                  <div className="form-group icon-group">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Full Name"
                      value={this.state.joint_holder_second_fullname}
                      onChange={(e) => this.setState({ joint_holder_second_fullname: e.target.value }, this.validateForm)}
                    />
                  </div>

                  <div className="form-group icon-group">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Mobile / Email"
                      value={this.state.joint_holder_second_mobile}
                      onChange={(e) => this.setState({ joint_holder_second_mobile: e.target.value }, this.validateForm)}
                    />
                  </div>

                  <div className="form-group">
                    <label style={{ fontSize: '13px', display: 'block', marginBottom: '5px' }}>Upload Signature Image</label>
                    <input
                      type="file"
                      accept=".jpg,.jpeg,.png"
                      onChange={(e) => this.handleFileUpload(e, "joint_holder_second_sign")}
                    />
                    {this.state.joint_holder_second_sign_uploading && <div style={{ fontSize: '12px', color: '#007bff' }}>Uploading...</div>}
                    {this.state.joint_holder_second_sign && <div style={{ fontSize: '12px', color: 'green' }}>✓ Signature uploaded successfully</div>}
                  </div>

                  <hr style={{ margin: '20px 0' }} />

                  <h4 style={{ fontSize: '15px', marginBottom: '15px', fontWeight: 'bold' }}>Third Joint Holder Details (Optional)</h4>
                  
                  <div className="form-group icon-group">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Full Name"
                      value={this.state.joint_holder_third_fullname}
                      onChange={(e) => this.setState({ joint_holder_third_fullname: e.target.value }, this.validateForm)}
                    />
                  </div>

                  <div className="form-group icon-group">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Mobile / Email"
                      value={this.state.joint_holder_third_mobile}
                      onChange={(e) => this.setState({ joint_holder_third_mobile: e.target.value }, this.validateForm)}
                    />
                  </div>

                  <div className="form-group">
                    <label style={{ fontSize: '13px', display: 'block', marginBottom: '5px' }}>Upload Signature Image</label>
                    <input
                      type="file"
                      accept=".jpg,.jpeg,.png"
                      onChange={(e) => this.handleFileUpload(e, "joint_holder_third_sign")}
                    />
                    {this.state.joint_holder_third_sign_uploading && <div style={{ fontSize: '12px', color: '#007bff' }}>Uploading...</div>}
                    {this.state.joint_holder_third_sign && <div style={{ fontSize: '12px', color: 'green' }}>✓ Signature uploaded successfully</div>}
                  </div>
                </div>
              )}

              <button
                className="btn btn-primary btn-block text-uppercase mt-4"
                type="button"
                onClick={this.handleSubmit}
              >
                Next
              </button>
            </form>
          </div>
        </div>
      </div><Footer /></div>
    );
  }
}
export default withRouter(AdditionalDetails);